import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Inventory from '../components/storage/Inventory.svelte';
import AddToStorage from '../components/storage/AddToStorage.svelte';
import { getActiveInventory, getStorageSummary } from '../lib/services/storage';
import { getSettings } from '../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { formatVolume } from '../lib/utils/units.ts';

var root_1 = $.from_html(`<div class="summary-bar svelte-2n3282l2ahsmt"><span class="summary-total svelte-2n3282l2ahsmt"> </span> <span class="summary-detail svelte-2n3282l2ahsmt"><!> <!> <!></span></div>`);
var root = $.from_html(`<!> <!> <div class="storage-page svelte-2n3282l2ahsmt"><!></div> <button class="fab svelte-2n3282l2ahsmt" aria-label="Add milk to storage"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="svelte-2n3282l2ahsmt"><path d="M12 5v14M5 12h14"></path></svg></button> <!>`, 1);

function Storage($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let entries = $.state($.proxy([]));
	let summary = $.state($.proxy({ fridge: 0, freezer: 0, deepFreezer: 0, total: 0 }));
	let showAdd = $.state(false);
	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadData();
	});

	async function loadData() {
		if (!$.get(activeChild)) return;

		$.set(entries, await getActiveInventory($.get(activeChild).id), true);
		$.set(summary, await getStorageSummary($.get(activeChild).id), true);
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Storage' });

	var node_1 = $.sibling(node, 2);

	{
		var consequent_3 = ($$anchor) => {
			var div = root_1();
			var span = $.child(div);
			var text = $.child(span);

			$.reset(span);

			var span_1 = $.sibling(span, 2);
			var node_2 = $.child(span_1);

			{
				var consequent = ($$anchor) => {
					var text_1 = $.text();

					$.template_effect(($0) => $.set_text(text_1, `Fridge ${$0 ?? ''}`), [() => formatVolume($.get(summary).fridge, $.get(isImperial))]);
					$.append($$anchor, text_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(summary).fridge > 0) $$render(consequent);
				});
			}

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_1 = ($$anchor) => {
					var text_2 = $.text();

					$.template_effect(($0) => $.set_text(text_2, `· Freezer ${$0 ?? ''}`), [
						() => formatVolume($.get(summary).freezer, $.get(isImperial))
					]);

					$.append($$anchor, text_2);
				};

				$.if(node_3, ($$render) => {
					if ($.get(summary).freezer > 0) $$render(consequent_1);
				});
			}

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent_2 = ($$anchor) => {
					var text_3 = $.text();

					$.template_effect(($0) => $.set_text(text_3, `· Deep ${$0 ?? ''}`), [
						() => formatVolume($.get(summary).deepFreezer, $.get(isImperial))
					]);

					$.append($$anchor, text_3);
				};

				$.if(node_4, ($$render) => {
					if ($.get(summary).deepFreezer > 0) $$render(consequent_2);
				});
			}

			$.reset(span_1);
			$.reset(div);
			$.template_effect(($0) => $.set_text(text, `${$0 ?? ''} total`), [() => formatVolume($.get(summary).total, $.get(isImperial))]);
			$.append($$anchor, div);
		};

		$.if(node_1, ($$render) => {
			if ($.get(summary).total > 0) $$render(consequent_3);
		});
	}

	var div_1 = $.sibling(node_1, 2);
	var node_5 = $.child(div_1);

	Inventory(node_5, {
		get entries() {
			return $.get(entries);
		},
		onrefresh: loadData
	});

	$.reset(div_1);

	var button = $.sibling(div_1, 2);
	var node_6 = $.sibling(button, 2);

	AddToStorage(node_6, {
		get open() {
			return $.get(showAdd);
		},
		onclose: () => $.set(showAdd, false),
		onsaved: loadData
	});

	$.delegated('click', button, () => $.set(showAdd, true));
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Storage = $.hmr(Storage);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-2n3282l2ahsmt');
		Storage[$.HMR].update(module.default);
	});
}

export default Storage;

$.delegate(['click']);
import "bun-svelte:Storage.svelte-1bbpnt16ox9zy-style.css";